import React from 'react';
import { Link } from 'react-router-dom';
import { Span } from '../element';
import Strings from '../../locales/Strings';

export const WizardStepFloatedItem = ({ path, menuText, status, testId, queryString }) => (
  <Span className="wrapper">
    <Span className={status}>
      <Link className="link" to={path + queryString} data-test-id={testId}>
        <Span className="circle">
          <Span className="inner" />
        </Span>
        <Span className="label">{Strings[menuText]}</Span>
      </Link>
    </Span>
  </Span>
);
